// Timestamp — a branded ISO-8601 UTC (Z-suffixed) wall-clock string.
//
// Lives in `@bilda/utils` (the ambient, browser-safe layer) so the
// renderer can mint timestamps honestly without pulling any package
// that touches a node builtin. `@bilda/app` re-exports this brand + its
// ctor unchanged, so every existing `A.Timestamp` / `A.mkTimestamp`
// importer keeps working through the shim.
//
// Stored as an ISO-8601 string (not ms since epoch) so an event log
// stays self-documenting when eyeballed —
// `"recordedAt": "2026-07-15T11:04:12.345Z"` beats
// `"recordedAt": 1784113740898` for a reader grepping the log months
// later. The brand keeps type-safety at the boundary; nothing parses
// the value as a Date today.
export { mkTimestamp };
// Trusting smart constructor — the caller guarantees a well-formed
// ISO-8601 UTC string (an injected `Clock` port, or a machine-minted
// `new Date().toISOString()` that cannot be malformed by construction).
// No parse: matching the historical `@bilda/app` ctor, whose Clock-port
// contract returns a `Timestamp` directly rather than a `Result`.
//
// The final `s as Timestamp` is the brand definition itself — the sole
// sanctioned `as` in the codebase's no-casts rule, isolated to this one
// constructor.
const mkTimestamp = (s) => s;
//# sourceMappingURL=timestamp.js.map